import React from "react";

const CarrierInfo = ({
  company_name,
  cargo_Inc_limit,
  icc_mc_number,
  cargo_insurance_company,
  liability_Inc_limit,
  agent_phone,
  Inc_deductible,
  driving_licence,
  cargo_Inc_agent,
  load_type,
  carrier_type,
  vehicle_image_url,
  isOwner = false,
}) => {
  return (
    <div className="row">
      <div className="col-md-3">
        {vehicle_image_url?.length > 0 && <img style={{ height: "190px", marginBottom: 30 }} src={vehicle_image_url} alt="vehicle img url"/>}
      </div>
      <div className="col-md-9">
        <div className="row">
        {isOwner && (
          <div className="col-lg-4 profile-info-boxes mb-3">
            <label>Company Name</label>
            <p>{company_name}</p>
          </div>
        )}

        <div className="col-lg-4 profile-info-boxes mb-3">
          <label>Carrier Type</label>
          <p>{carrier_type}</p>
        </div>

        <div className="col-lg-4 profile-info-boxes mb-3">
          <label>Load Type</label>
          <p>{load_type}</p>
        </div>

        <div className="col-lg-4 profile-info-boxes mt-3">
          <label>Cargo Ins. Limit </label>
          <p>{cargo_Inc_limit}</p>
        </div>

        {isOwner && (
          <div className="col-lg-4 profile-info-boxes mt-3">
            <label>Agent Phone</label>
            <p>{agent_phone}</p>
          </div>
        )}

        <div className="col-lg-4 profile-info-boxes mt-3">
          <label>Liability Ins. Limit</label>
          <p>{liability_Inc_limit}</p>
        </div>

        <div className="col-lg-4 profile-info-boxes mt-3">
          <label>Ins. Deductible</label>
          <p>{Inc_deductible}</p>
        </div>

        <div className="col-lg-4 profile-info-boxes mt-3">
          <label>Cargo Insurance Company</label>
          <p>{cargo_insurance_company}</p>
        </div>

        <div className="col-lg-4 profile-info-boxes mt-3">
          <label>ICC MC Numbers</label>
          <p>{icc_mc_number}</p>
        </div>

        <div className="col-lg-4 profile-info-boxes mt-3">
          <label>Cargo Inc. Agent</label>
          <p>{cargo_Inc_agent}</p>
        </div>

        {isOwner && (
          <div className="col-lg-4 profile-info-boxes mt-3">
            <label>Driving Licence</label>
            <p>{driving_licence}</p>
          </div>
        )}
      </div>
      </div>
    </div>
  );
};

export default React.memo(CarrierInfo);
